import { render, staticRenderFns } from "./UpdateFile.vue?vue&type=template&id=04c24382&scoped=true"
import script from "./UpdateFile.vue?vue&type=script&lang=js"
export * from "./UpdateFile.vue?vue&type=script&lang=js"
import style0 from "./UpdateFile.vue?vue&type=style&index=0&id=04c24382&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c24382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c24382')) {
      api.createRecord('04c24382', component.options)
    } else {
      api.reload('04c24382', component.options)
    }
    module.hot.accept("./UpdateFile.vue?vue&type=template&id=04c24382&scoped=true", function () {
      api.rerender('04c24382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/kyc/UpdateFile.vue"
export default component.exports